
import axios from '@/axios.js'
import url from '@/url.js'

export default {
  getMenus({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      let add = ''
      if(payload.id !== undefined){
        add = `/${payload.id}`
      }
      const conn = {
        method: 'get',
        url: `${url.base}/menu${add}`,
        params: payload,
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        commit('SET_TOTAL', res.data.recordsTotal)
        commit('SET_MENU_LIST', res.data.data)
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
  getSubMenus({ }, payload) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      let add = ''
      if(payload.id !== undefined){
        add = `/${payload.id}`
      }
      const conn = {
        method: 'get',
        url: `${url.base}/sub-menu${add}`,
        params: payload,
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
  cudSubMenus({ }, payload) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      const conn = {
        method: 'post',
        url: `${url.base}/input/sub-menu`,
        data: payload,
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
  cudMenus({ }, payload) {
    return new Promise((resolve, reject) => {
      const profiles = JSON.parse(localStorage.getItem('profileAccess'))
      const conn = {
        method: 'post',
        url: `${url.base}/input/menu`,
        data: payload,
        headers: {
          'device': 'web-admin',
          'Authorization': `bearer ${profiles.tokens}`,
          'secret' : url.secret
        }
      }
      axios(conn).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
  
}
